import { EuiLink } from "@elastic/eui";
import { FormattedMessage } from "react-intl";
import React from "react";

import AbstractColumnActions from "../../shared/entity/TableColumnAction";

const columns = (actions) => [
    {
        field: "id",
        name: "ID",
        sortable: true,
        render: (item) => (
            <span>
                <EuiLink>#{item}</EuiLink>
            </span>
        ),
        width: 70,
    },
    {
        field: "nameAr",
        name: <FormattedMessage id="location-category.nameAr" />,
        sortable: true,
    },
    {
        field: "nameEn",
        name: <FormattedMessage id="location-category.nameEn" />,
        sortable: true,
    },
    {
        field: "createdAt",
        name: <FormattedMessage id="location-category.created-at" />,
        dataType: "date",
        sortable: true,
    },
    {
        field: "updatedAt",
        name: <FormattedMessage id="location-category.updated-at" />,
        dataType: "date",
        sortable: true,
    },
    {
        name: "Actions",
        isActionsPopover: true,
        actions: AbstractColumnActions(actions),
    },
];

export default columns;
